import { makeStyles } from '@material-ui/core/styles';
import Card from 'components/CncUI/Card';

import InfoPanel from './InfoPanel';
import EditPanel from './EditPanel';
import EditAction from '../Shared/EditAction';

const useStyles = makeStyles(() => ({
  content: {
    padding: '40px 24px',
    paddingBottom: '56px !important',
  },
}));

const LoanOutPanel = ({ state, offer, loanout, updateParent, existing }) => {
  const classes = useStyles();

  const onEdit = () => {
    if (!loanout && existing.length) {
      updateParent({ showExisting: true });
    } else {
      updateParent({ edit: true });
    }
  };

  return (
    <Card>
      <Card.Title action={state.edit ? null : <EditAction action={onEdit} />}>
        Loan-out Information
      </Card.Title>
      <Card.Content className={classes.content}>
        {state.edit ? (
          <EditPanel
            offer={offer}
            loanout={loanout}
            cancel={() => updateParent({ edit: false })}
            reload={() =>
              updateParent({ edit: false, reload: true, reloadHistory: true })
            }
          />
        ) : (
          <InfoPanel offer={offer} loanout={loanout} />
        )}
      </Card.Content>
    </Card>
  );
};

export default LoanOutPanel;
